import i18n from '../../i18n'
import axios from 'axios';
import config from '@/../config.js'

const getTokenHeader = () => {
    return {"Authorization" : "Bearer " + localStorage.getItem('9manad_manage_token')}
}

export default {
    
    isLogin(){
        var token = localStorage.getItem('9manad_manage_token')
        return token != undefined && token != null
    }

    ,setToken(token){
        if(token!=null){
            localStorage.setItem('9manad_manage_token',token)
        }else{
            localStorage.removeItem('9manad_manage_token')
        }
        
    }
    ,setMenuList(menu_list){
        localStorage.setItem('9manad_manage_menu_list',JSON.stringify(menu_list))
    }
    ,setUsername(username){
        localStorage.setItem('9manad_manage_username',username)
    }
    ,setDisplayname(displayname){
        localStorage.setItem('9manad_manage_displayname',displayname)
    }
    ,setLang(lang){
        localStorage.setItem('9manad_manage_lang',lang)
    }

    ,getTokenHeader
    ,getMenuList(){
        var menu_list = localStorage.getItem('9manad_manage_menu_list') 
        
        if(!menu_list) return []

        menu_list = JSON.parse(menu_list)
        let new_menu_list= []
        if(menu_list.includes('dashboard')){
            new_menu_list.push({ title: i18n.t('Menu_Dashboard'), icon: 'mdi-book-open-page-variant' , value:'menu_dashboard' , name: 'Dashboard_0'})
        }
        //new_menu_list.push({ title: i18n.t('Menu_Dashboard2'), icon: 'mdi-book-open-page-variant' , value:'menu_dashboard2' , name: 'Dashboard_02'})
        if(menu_list.includes('staff')){
            new_menu_list.push({ title: i18n.t('Menu_Staff'), icon: 'mdi-account-multiple' , value:'menu_staff' , name: 'Staff'})
        }
        if(menu_list.includes('station')){
            new_menu_list.push({ title: i18n.t('Menu_Station'), icon: 'mdi-home' , value:'menu_station' , name: 'Station'})
        }
        if(menu_list.includes('member_list')){  
            new_menu_list.push({ title: i18n.t('Menu_Member'), icon: 'mdi-account-check' , value:'menu_member_list' , name: 'Member_0'})
        }
        new_menu_list.push({ title: i18n.t('Menu_Appointment_Guide'), icon: 'mdi-qrcode-scan' , value:'menu_appointment_guide' , name: 'Appointment_Guide_0'})
        if(menu_list.includes('reservation_list')){
            new_menu_list.push({ title: i18n.t('Menu_Appointment_List'), icon: 'mdi-calendar-clock' , value:'menu_appointment_list' , name: 'Appointment_List_0'})
        }
        if(menu_list.includes('reservation_group')){
            new_menu_list.push({ title: i18n.t('Menu_Appointment_Group'), icon: 'mdi-menu' , value:'menu_appointment_group' , name: 'Appointment_Group_0'})
        }
        if(menu_list.includes('automessage')){
            new_menu_list.push({ title: i18n.t('Menu_Automessage'), icon: 'mdi-message-alert' , value:'menu_automessage' , name: 'Automessage_0'})
        }
        if(menu_list.includes('noti')){
            new_menu_list.push({ title: i18n.t('Menu_Line_Noti'), icon: 'mdi-timer' , value:'menu_noti' , name: 'Admin_Noti'})
        }
        
        if(menu_list.includes('package')){
            new_menu_list.push({ title: i18n.t('Menu_Package'), icon: 'mdi-hexagon-slice-6' , value:'menu_package' , name: 'Package'})
        }
        if(menu_list.includes('extpackage')){
            new_menu_list.push({ title: i18n.t('Menu_ExtPackage'), icon: 'mdi-hexagon-slice-2' , value:'menu_ext_package' , name: 'ExtPackage'})
        }
        if(menu_list.includes('customer_package')){
            new_menu_list.push({ title: i18n.t('Menu_CustomerPackage'), icon: 'mdi-head-dots-horizontal-outline' , value:'menu_customer_package' , name: 'CustomerPackage'})
        }
        if(menu_list.includes('customer_billing')) {
            new_menu_list.push({ title: i18n.t('Menu_CustomerBilling'), icon: 'mdi-heart-box-outline' , value:'menu_customer_billing' , name: 'CustomerBilling_0'})
        }
        if(menu_list.includes('customer')){
            new_menu_list.push({ title: i18n.t('Menu_Customer'), icon: 'mdi-account-cog' , value:'menu_customer' , name: 'Customer'})
        }

        if(menu_list.includes('specialmarketsetting')){
            new_menu_list.push({ title: i18n.t('Menu_Special_Market_Setting'), icon: 'mdi-cart-outline' , value:'menu_special_market_setting' , name: 'Special_Market_Setting'})
        }
        if(menu_list.includes('specialmarketorder')){
            new_menu_list.push({ title: i18n.t('Menu_Special_Market_Order'), icon: 'mdi-cart-outline' , value:'menu_special_market_order' , name: 'Special_Market_Order'})
        }
        new_menu_list.push({ title: i18n.t('Menu_Manual'), icon: 'mdi-note-text' , value:'menu_manual' , name: 'Manual'})
        new_menu_list.push({ title: i18n.t('Menu_Logout'), icon: '' , value:'menu_logout' , name: 'Logout'})
        
        return new_menu_list
    }
    ,getUsername(){
        var username = localStorage.getItem('9manad_manage_username')
        if(!username) username =  ''
        return username
    }
    ,getLang(){
        var lang = localStorage.getItem('9manad_manage_lang')
        if(!lang) lang =  process.env.VUE_APP_I18N_LOCALE || 'th'
        return lang
    }
    ,getPermission(name,val=null){
        var permission_id_list = []
        var toid = null
        if(name=='Staff'){
            permission_id_list = [5,6,7,13]
        }else if(name=='Station'){
            permission_id_list = [1]
        }else if(name=='StationDetail'){
            permission_id_list = [2,3,4]
            toid = 2
        }else if(name=='AppointmentGroup'){
            permission_id_list = [2,9]
            toid = 2
        }else if(name=='AppointmentGroupDetail'){
            permission_id_list = [8,25]
            toid = 2
        }else if(name=='AppointmentList'){
            permission_id_list = [15,16,18,19,20,21,22]
            toid = 2
        }else if(name=='Automessage'){
            permission_id_list = [23]
            toid = 2
        }else if(name=='SpecialMarket'){
            permission_id_list = [32,33]
        }
        return axios
        .post(config.api.url.manage.staff.get_permission,{permission_id_list:permission_id_list,toid:toid,toid_value:val},{ headers: getTokenHeader()}
        ).then(response => {
            return response.data
        })
    }
}